<template>
  <el-container style="height: 100%">
    <el-header height="60px">
      <nav-top></nav-top>
    </el-header>
    <el-container style="height: calc(100% - 60px)">
      <el-aside width="240px">
        <left-bar></left-bar>
      </el-aside>
      <div style="height: 100%;width: 100%">
        <nav-tab style="height: 40px;width: 100%"></nav-tab>
        <keep-alive>
          <div class="router-container">
            <router-view/>
          </div>
        </keep-alive>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import leftBar from '../components/home/leftBar'
import navTab from '../components/home/navTab'
import navTop from '../components/home/navTop'
export default {
  name: 'home',
  components: {navTop, navTab, leftBar}
}
</script>

<style>
.el-header{
  padding: 0;
}
</style>
<style scoped>
.router-container{
  height: calc(100% - 80px);
  width: calc(100% - 40px);
  padding: 20px;
  background-color: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue